// Synthesised sound design (WebAudio, no audio files). Off until the viewer turns it on.
let ctx = null, master = null, drone = null;

function ensure() {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = 0.5;
    master.connect(ctx.destination);
  }
  if (ctx.state === "suspended") ctx.resume();
}

function tone(freq, dur, { type = "sine", gain = 0.12, slide = 0, delay = 0 } = {}) {
  const t = ctx.currentTime + delay, o = ctx.createOscillator(), g = ctx.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  if (slide) o.frequency.exponentialRampToValueAtTime(freq * slide, t + dur);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(master);
  o.start(t);
  o.stop(t + dur + 0.05);
}

function noise(dur, gain = 0.2, cutoff = 900) {
  const b = ctx.createBuffer(1, ctx.sampleRate * dur, ctx.sampleRate), d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length) ** 2;
  const s = ctx.createBufferSource(), f = ctx.createBiquadFilter(), g = ctx.createGain();
  s.buffer = b; f.type = "lowpass"; f.frequency.value = cutoff; g.gain.value = gain;
  s.connect(f).connect(g).connect(master);
  s.start();
}

export function setSound(on) {
  if (!on) {
    if (drone) { drone.forEach((n) => n.stop()); drone = null; }
    return;
  }
  ensure();
  if (drone) return;
  const f = ctx.createBiquadFilter(), g = ctx.createGain();
  f.type = "lowpass"; f.frequency.value = 220; g.gain.value = 0.05;
  drone = [55, 55.4, 82.5].map((hz) => {
    const o = ctx.createOscillator();
    o.type = "sawtooth"; o.frequency.value = hz; o.connect(f); o.start();
    return o;
  });
  f.connect(g).connect(master);
}

export function cue(kind) {
  if (!ctx || !drone) return;
  if (kind === "beat") tone(660, 0.18, { type: "triangle", gain: 0.05, slide: 1.5 });
  if (kind === "packet") tone(1200, 0.08, { gain: 0.03 });
  if (kind === "pass") { tone(880, 0.12, { gain: 0.06 }); tone(1320, 0.18, { gain: 0.05, delay: 0.08 }); }
  if (kind === "fail") tone(140, 0.45, { type: "square", gain: 0.06, slide: 0.7 });
  if (kind === "confirm") { noise(0.25, 0.35, 500); tone(70, 0.4, { gain: 0.2, slide: 0.6 }); tone(1760, 0.25, { gain: 0.04, delay: 0.05 }); }
  if (kind === "exit") tone(520, 0.35, { type: "triangle", gain: 0.06, slide: 0.5 });
}
